import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

const alertVariants = cva("rounded-lg border px-4 py-2 text-sm animate-fade-in", {
  variants: {
    variant: {
      destructive:
        "bg-destructive/10 border-destructive/20 text-destructive",
      success: "bg-success/10 border-success/20 text-success",
      warning:
        "bg-warning/10 border-warning/20 text-warning-foreground",
    },
  },
  defaultVariants: {
    variant: "destructive",
  },
});

export interface AlertProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertVariants> {}

export const Alert = forwardRef<HTMLDivElement, AlertProps>(
  ({ className, variant, ...props }, ref) => (
    <div
      ref={ref}
      role="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  ),
);
Alert.displayName = "Alert";

export { alertVariants };
